import _ from "lodash"
import { observer } from "mobx-react-lite"
import * as React from "react"
import { ImageBackground, ImageStyle, StyleProp, View, ViewStyle } from "react-native"
import { translate } from "../../i18n"
import { color } from "../../theme"
import config from "../../utils/config"
import { AutoImage } from "../auto-image/auto-image"
import { Text } from "../text/text"


const CONTAINER: ImageStyle = {
  width: '100%',
  height: '100%',
  resizeMode: 'cover',
  backgroundColor: color.palette.black
}

const IMG_STYLE: ImageStyle = {
  opacity: 0.5
}
const WRAPPER: ViewStyle = {
  height: '100%',
  paddingHorizontal: 16,
  paddingTop: 42
}

const HEIGHT: ViewStyle = {
  // height: '45%'
}

const PROFILE: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 12,
}

const IMG_AVATAR: ImageStyle = {
  height: 36,
  width: 36,
  borderRadius: 18,
  marginRight: 8
}

const CONTENT: ViewStyle = {
  flexGrow: 1,
}

const BOTTOM: ViewStyle = {
  marginBottom: 64,
  flex: 1,
  justifyContent: 'flex-end',
  alignItems: 'flex-end'
}

const IMG_LOGO: ImageStyle = {
  height: 36,
  width: 150,
  alignItems: 'center',
  resizeMode: 'contain',
}

export interface InstagramStoryPostLayoutProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  post?: any
  onLoadEnd?: () => void
  forwardRef?: any
}

const { BASE_URL } = config();

/**
 * Describe your component here
 */
export const InstagramStoryPostLayout: React.FC<React.ForwardedRef<any> & InstagramStoryPostLayoutProps> = observer(function InstagramStoryPostLayout(props: InstagramStoryPostLayoutProps) {
  const { post, forwardRef, onLoadEnd } = props

  const img = `${BASE_URL}/storage/${post.image}`
  const avatar = post.author && post.author.avatar ? { uri: `${BASE_URL}/img/cache/medium/${post.author.avatar}` } : require("./avatar.png")
  const jalaAppsUdang = require("./jala-apps-udang.png")

  return (
    <ImageBackground style={CONTAINER} ref={forwardRef} imageStyle={IMG_STYLE} source={{ uri: img }} onLoadEnd={onLoadEnd}>
      <View style={WRAPPER}>
        <View style={HEIGHT} />
        <View style={PROFILE}>
          {post.author && (<AutoImage source={avatar} style={IMG_AVATAR} />)}
          <Text preset="body1" shadow="1" text={`${post.author ? post.author.name : 'JALA'}`} color={color.palette.white} />
        </View>
        <Text preset="display2" shadow="2" mb="8px" text={post.title} color={color.palette.white} />
        <View style={CONTENT}>
          <Text preset="body1" shadow="1" mb="32px" text={post.excerpt} color={color.palette.white} />
        </View>
        <View style={BOTTOM}>
          <Text preset="body1" shadow="1" mb="16px" text={_.upperFirst(translate('posts.read_complete_article_only_on'))} color={color.palette.white} />
          <AutoImage source={jalaAppsUdang} style={IMG_LOGO} resizeMethod="resize" />
        </View>
      </View>
    </ImageBackground>
  )
})
